import { INCODE_STATUS, INCODE_STATUS_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const getIncodeStatusAction = (params) => async (dispatch) => {
  const { interview_id } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `/api/linked-up/${interview_id}/v2/status`,
      {
        platform: 'web',
      },
      {
        withApiKey: true,
      },
    );

    const { data, status } = response || {};

    dispatch({
      method: 'post',
      payload: data || {},
      status: status || {},
      type: INCODE_STATUS,
    });
  } catch (e) {
    dispatch({
      method: 'post',
      payload: e || {},
      type: INCODE_STATUS_ERROR,
    });
  }
};
